/** @type {ActionType} */
export const pbr_email_design_requested = 'pbr_email_design_requested';
